import { render, staticRenderFns } from "./SubMemu.vue?vue&type=template&id=d2b43004&"
import script from "./SubMemu.vue?vue&type=script&lang=js&"
export * from "./SubMemu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports